import {formatDateToBR} from "../../../../../utils/time";
import {SETableColumnsProps} from "../../../../components/SETable";
import {Grid, IconButton} from "@mui/material";
import {
  RiCheckboxCircleFill,
  RiCloseCircleFill,
  RiDeleteBin6Line,
  RiErrorWarningFill,
  RiPencilLine,
} from "react-icons/ri";
import React from "react";
import SETableIconButton from "../../../../components/SETable/SETableIconButton";

interface TableColumnsProps {
  handleEdit?: (data?: any) => void;
  handleCopy?: (data?: any) => void;
  handleUpdateStatus?: (data?: any) => void;
  handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
  handleEdit = () => {},
  handleDelete = () => {},
  handleUpdateStatus = () => {},
}: TableColumnsProps): SETableColumnsProps[] => [
  {
    id: 'dataCriacao',
    label: 'Data',
    customField: formatDateToBR,
  },
  {
    id: 'plataforma',
    label: 'Loja',
    align: 'left',
  },
  {
    id: 'versao',
    label: 'Versão',
    align: 'left',
  },
  {
    id: "status",
    label: "Status",
    align: "center",
    sortable: false,
    width: 320,
    customField: (value: any, row: any) => (
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={6} container alignItems="center" justifyContent="center">
          <IconButton onClick={() => handleUpdateStatus(row)}>
            <>
              {value === "APROVADO" && (
                <RiCheckboxCircleFill size={26} color="#66BD91" title={'Aprovado'} />
              )}
              {(value === "PENDENTE" || value === null) && (
                <RiErrorWarningFill size={26} color="#F6E566" title={'Pendente'}/>
              )}
              {(value === "REPROVADO" || value === "DESAPROVADO") && (
                <RiCloseCircleFill size={26} color="#FF0000" title={'Reprovado'}/>
              )}
            </>
          </IconButton>
          <SETableIconButton onClick={() => handleEdit(row)}>
            <RiPencilLine size={20} color="#555770" />
          </SETableIconButton>
          <SETableIconButton onClick={() => handleDelete(row.id)}>
            <RiDeleteBin6Line size={20} color="#555770" />
          </SETableIconButton>
        </Grid>
      </Grid>
    ),
  },
];
